"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('init', function () {
    this.frameId = false;
    this.namespace = false;
    /*
        Configuration for every spine-based application.

        1.) Extract params of the url
        2.) Font.stylefill
        3.) Initializes observers
        4.) In case the client wants to customize individual frames, the param frameSetting has to be an array containing the settings for the frameID in the config in the client.config
    */
    this.configure = function () {
        if (this.checkIfAllowed()) {
            namespace_1.default.debug.showInfo('Configuring');
            this.cloneConfig();
            if (namespace_1.default.visual[this.namespace].config.frameSetting && namespace_1.default.visual[this.namespace].config.frameSetting[this.frameId]) {
                this.getOptionalComponents();
            }
            else {
                this.start();
            }
        }
        else {
            document.getElementById(this.frameId).innerHTML = '<p style="left: 50%; transform: translate(-50%,-50%); top: 50%; font-size:12px; position: absolute;">You tried to embed Visuals from an APA-domain. That is not allowed. Please contact your tech-staff in order to receive the correct embed-link.</p>';
        }
    };
    this.checkIfAllowed = function () {
        var url = (window.location != window.parent.location) ? document.referrer : document.location.href;
        var tBool = false;
        if (namespace_1.default.visual[this.namespace].config.whitelist) {
            var whitelist = namespace_1.default.visual[this.namespace].config.whitelist;
        }
        else {
            return true;
        }
        for (var i = 0; i < whitelist.length; i++) {
            if (url.indexOf(whitelist[i]) > -1) {
                tBool = true;
            }
        }
        return tBool;
    };
    /*
        Initializes the observer of the application, e.g. apa.visual.sport.observer.
        In case we dont have an observer defined, this function won't throw an error.
    */
    this.observers = function () {
        var _this = this;
        namespace_1.default.debug.showInfo('Initializing observers');
        if (!namespace_1.default.items[this.frameId].config.codebase) {
            namespace_1.default.debug.showError('There is no app-namespace defined');
        }
        else {
            var codebase = this.namespace;
            var observer = namespace_1.default.visual[codebase].observer;
            if (observer) {
                Object.keys(observer).forEach(function (index) {
                    var tObserver = new observer[index]();
                    tObserver.namespace = _this.namespace;
                    tObserver.frameId = _this.frameId;
                    tObserver.init();
                });
            }
        }
    };
    /*
        Every frame needs its own config, therefore we need to clone the visual config into the items
    */
    this.cloneConfig = function () {
        namespace_1.default.utils.extendDeep(namespace_1.default.items[this.frameId].config, namespace_1.default.visual[this.namespace].config);
    };
    /*
        Every Client has a client.css which is named like the codebase, e.g. clientcss/client.sport.css
        Every Client has a client.script which is named like the codebase, e.g. clientscript/client.sport.js
    */
    this.getOptionalComponents = function () {
        var _this = this;
        var defArr = [];
        var frameSetting = namespace_1.default.visual[this.namespace].config.frameSetting[this.frameId];
        var defObj;
        if (frameSetting.sheet) {
            defObj = jquery_1.default.Deferred();
            this.appendOptionalStyle(namespace_1.default.params.paths.client.css + '/client.' + this.frameId + '.css', defObj);
            defArr.push(defObj);
        }
        if (frameSetting.script) {
            defObj = jquery_1.default.Deferred();
            this.loadOptionalScript(namespace_1.default.params.paths.client.script + '/client.' + this.frameId + '.js', defObj);
            defArr.push(defObj);
        }
        if (frameSetting.config) {
            defObj = jquery_1.default.Deferred();
            this.loadOptionalConfig(namespace_1.default.params.paths.client.config + '/client.config.' + this.frameId + '.js', defObj);
            defArr.push(defObj);
        }
        if (defArr.length == 0) {
            this.start();
        }
        else {
            jquery_1.default.when.apply(this, defArr).then(function (ev) { return _this.start(ev); });
        }
    };
    /*
        Loads optional client styles (first element of the array will always be the default client css file)
    */
    this.appendOptionalStyle = function (sheet, deferred) {
        namespace_1.default.debug.showInfo('Appending optional styles for frame: ' + this.frameId);
        var tag = (0, jquery_1.default)('<style id="apaClientStyle_' + this.frameId + '"></style>');
        (0, jquery_1.default)('head').append(tag);
        (0, jquery_1.default)('#apaClientStyle_' + this.frameId).load(sheet, function (responseText, textStatus) {
            if (textStatus == 'error') {
                console.info('↑↑↑>>> "' + sheet + '" is optional! Ignore the error or create an empty file. <<<↑↑↑');
            }
            else {
                /* there was a client-stylesheet found, send an append-event to the stylefills-observer */
                var tEvent = jquery_1.default.Event(namespace_1.default.events.stylefills.append);
                tEvent.content = sheet;
                (0, jquery_1.default)(document).triggerHandler(tEvent);
            }
        });
        deferred.resolve();
    };
    /*
        Loads optional client configs (first element of the array will always be the default client config)
    */
    this.loadOptionalConfig = function (config, deferred) {
        var loader = new namespace_1.default.loader.configs.frame();
        var defObj = jquery_1.default.Deferred();
        loader.setOptions({
            deferred: defObj,
            url: config,
            jsonpCallback: 'apaCallbackConfigClient_' + this.frameId
        });
        loader.frameId = this.frameId;
        loader.load();
        jquery_1.default.when(defObj).then(function () {
            deferred.resolve();
        });
    };
    /*
        Loads optional client scripts (first element of the array will always be the default client script)
    */
    this.loadOptionalScript = function (script, deferred) {
        var loader = new namespace_1.default.loader.scripts();
        var defObj = jquery_1.default.Deferred();
        loader.setOptions({
            url: script,
            deferred: defObj
        });
        loader.load();
        jquery_1.default.when(defObj).then(function () {
            deferred.resolve();
        });
    };
    /*
        Processes the frame-attributes, gets the frame-specific deeplinks and sends an event to the stylefills-observer in order to tell that all possible scripts have been loaded.

            When the stylefills-observer is done, this will get a message, initialize the framework controller and hand over the frameId ( e.g. adler1 )
    */
    this.start = function () {
        namespace_1.default.debug.showInfo('Starting');
        var config = namespace_1.default.items[this.frameId].config;
        namespace_1.default.language.set(config.language, this.frameId);
        this.getFrameAttributes();
        namespace_1.default.url.getFrameParams(this.frameId);
        this.observers();
        var framework = this.getFramework(this.frameId);
        framework.init();
        var tEvent = jquery_1.default.Event(namespace_1.default.events.stylefills.visualDone);
        (0, jquery_1.default)(document).triggerHandler(tEvent);
        if (config.view.scaledown) {
            this.scaleDown();
            window.addEventListener("resize", this.scaleDown.bind(this));
        }
        if (namespace_1.default.debugmode)
            this.setDebugMode();
    };
    this.scaleDown = function () {
        var config = namespace_1.default.items[this.frameId].config;
        var parent = (0, jquery_1.default)('#' + this.frameId).parent();
        var height = parent.innerHeight();
        var width = parent.innerWidth();
        if (width < config.view.scaledown) {
            if (height == 0)
                height = window.innerHeight; // for iframes
            if (height == 0)
                height = width; // for i don't know, we just want to have a height
            var originWidth = 500; // base width
            var originHeight = 500; // base height
            if (height > width)
                originHeight = originHeight * (height / width); // in case of height is higher than width, we want to scale it with the ratio
            if (width > height)
                originWidth = originWidth * (width / height); // same but opposite
            var ratio = width / originWidth; // calc the ratio between width an originWidth
            var transformLeft = ((originWidth - (originWidth * ratio)) / 2); // translate variable also has to be calculated, becauso without translate, the visual would always be in the middle of it self, which means not in the center of its frame
            var transformTop = ((originHeight - (originHeight * ratio)) / 2);
            if (transformLeft < 0) { // if the graphic is higher or wider than the 500px of the origin, we also want it to work properly
                transformLeft = Math.abs(transformLeft);
            }
            else if (transformLeft > 0) {
                transformLeft = 0 - transformLeft;
            }
            if (transformTop < 0) { // same
                transformTop = Math.abs(transformTop);
            }
            else if (transformTop > 0) {
                transformTop = 0 - transformTop;
            }
            (0, jquery_1.default)('#' + this.frameId).attr('style', 'height:' + originHeight + 'px !important; width: ' + originWidth + 'px !important; transform: translate(' + transformLeft + 'px, ' + transformTop + 'px) scale(' + ratio + ')');
        }
    };
    this.setDebugMode = function () {
        var _this = this;
        var tHtml = '';
        var element = document.getElementById(this.frameId);
        var config = namespace_1.default.items[this.frameId].config;
        tHtml += '<div class="apa-debugmode_' + this.frameId + '" style="color:#88ff00; overflow:auto;z-index:100;position:absolute;top:0px;left:0px;right:0px;bottom:0px;background-color:black;opacity:0.9;padding:10px;box-sizing:border-box;font-size:12px;">';
        tHtml += '<table style="border-bottom: 1px solid grey;">';
        tHtml += '<tr style="border-bottom: 1px solid grey;">';
        tHtml += '<td style="padding: 5px;vertical-align:top">Data:</td>';
        tHtml += '<td class="apa-loadeddata_' + this.frameId + '" style="padding: 5px;"></td>';
        tHtml += '</tr>';
        tHtml += '<tr style="border-bottom: 1px solid grey;">';
        tHtml += '<td style="padding: 5px;vertical-align:top">URL:</td>';
        tHtml += '<td style="padding: 5px;"><pre style="white-space: pre-wrap;">' + document.location.href + '</pre></td>';
        tHtml += '</tr>';
        tHtml += '<tr style="border-bottom: 1px solid grey;">';
        tHtml += '<td style="padding: 5px;vertical-align:top">apaOuterFrame:</td>';
        tHtml += '<td style="padding: 5px;"><pre style="white-space: pre-wrap;">' + element.outerHTML.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</pre></td>';
        tHtml += '</tr>';
        tHtml += '<tr>';
        tHtml += '<td style="padding: 5px;vertical-align:top">Config:</td>';
        tHtml += '<td style="padding: 5px;"><pre>' + JSON.stringify(config, undefined, 10).replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</pre></td>';
        tHtml += '</tr>';
        tHtml += '</table>';
        tHtml += '</div>';
        element.parentElement.innerHTML += tHtml;
        document.getElementsByClassName('apa-debugmode_' + this.frameId)[0].addEventListener("click", function (ev) { return _this.swapFullscreen(ev); });
    };
    this.swapFullscreen = function () {
        var element = document.getElementsByClassName('apa-debugmode_' + this.frameId)[0];
        if (element.style.opacity == '0.9') {
            element.style.opacity = '1';
            element.style.position = 'fixed';
            element.style.zIndex = '101';
        }
        else {
            element.style.opacity = '0.9';
            element.style.position = 'absolute';
            element.style.zIndex = '100';
        }
    };
    // data-attributes that have been put into the frame-tag are checked for relevance and update the frame-specific config
    this.getFrameAttributes = function () {
        var _this = this;
        Object.keys(namespace_1.default.items[this.frameId].config.frame).forEach(function (key) {
            if (key.indexOf('data-') > -1 && key != 'data-package') { // keys that are no data-attributes are left out, data-package does not apply
                var value = namespace_1.default.items[_this.frameId].config.frame[key];
                if (key === 'data-view') {
                    var newParams = {};
                    var tParamsArr = value.split('-'); // params split by '-'
                    var config = namespace_1.default.items[_this.frameId].config;
                    tParamsArr.forEach(function (key) {
                        var _a;
                        var paramPair = key.split(':');
                        var tAttribute = paramPair[0].toString(); //competition
                        var tValue = paramPair[1].toString(); //co13
                        newParams[tAttribute] = _this.getVal(tValue, (_a = config.view) === null || _a === void 0 ? void 0 : _a[tAttribute], tAttribute);
                    });
                    namespace_1.default.utils.extend(config.view, newParams);
                }
                else {
                    var tOk = true;
                    var tKeyArr = key.replace('data-', '').split('-');
                    var tVar = namespace_1.default.items[_this.frameId].config;
                    tKeyArr.forEach(function (key) {
                        if (Object.prototype.hasOwnProperty.call(tVar, key)) {
                            tVar = tVar[key];
                        }
                        else {
                            tOk = false;
                            return false;
                        }
                    });
                    if (tOk) {
                        // only allowed if data-param is also set in config
                        var tValue = _this.getVal(value, tVar, tKeyArr);
                        var tObj = namespace_1.default.items[_this.frameId].config;
                        for (var i = 0; i < tKeyArr.length - 1; i++) {
                            tObj = tObj[tKeyArr[i]];
                        }
                        tObj[tKeyArr[tKeyArr.length - 1]] = tValue;
                    }
                }
            }
        });
    };
    /*
        In case of array, parses the string to array
    */
    this.getVal = function (value, origValue, attribute) {
        if (Array.isArray(origValue)) { // value is an array
            if (value == '')
                return [];
            var returnArr = value.split(',');
            return returnArr;
        }
        else if (this.isInt(origValue)) { // value is an int
            try {
                return parseInt(value, 10);
            }
            catch (e) {
                console.warn('data-param(' + attribute + ') has to be int');
            }
        }
        else if (this.isFloat(origValue)) { // value is an float
            try {
                return parseFloat(value);
            }
            catch (e) {
                console.warn('data-param(' + attribute + ') has to be float');
            }
        }
        else { // value is string
            if (value === 'true') {
                return true;
            }
            else if (value === 'false') {
                return false;
            }
        }
        return value;
    };
    this.isInt = function (n) {
        return Number(n) === n && n % 1 === 0;
    };
    this.isFloat = function (n) {
        return Number(n) === n && n % 1 !== 0;
    };
    /*
        We have to pass the frameId to the framework controller
    */
    this.getFramework = function () {
        namespace_1.default.debug.showError('init.getFramework has to be extended');
    };
});
